import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringLimit'
})
export class StringLimitPipe implements PipeTransform {

    transform(value: string): any {
        if (value.length > 100) {
           value = `${value.slice(0 , 100)}...`;
        }
        return value;
    }
}
